document.addEventListener('click', async (e) => {
  const pickerOption = e.target.closest('.product-card-wrapper .product-card-variant-picker .variant-option');

  // Seleção de tamanho
  if (pickerOption) {
    const variantPickerWrapper = pickerOption.closest('.product-card-wrapper .product-card-variant-picker');
    variantPickerWrapper.querySelectorAll('.variant-option').forEach(b => b.classList.remove('active'));
    pickerOption.classList.add('active');

    const variantId = pickerOption.dataset.variantId;
    const actionBtn = variantPickerWrapper.querySelector('.product-card-wrapper .product-card-variant-picker .variant-action');
    actionBtn.removeAttribute('disabled');
    actionBtn.textContent = 'ADICIONAR A SACOLA';
    actionBtn.dataset.variantId = variantId;
    return;
  }

  const variantActionBtn = e.target.closest('.variant-action');

  // Clique no botão de ação
  if (variantActionBtn && variantActionBtn.dataset.variantId) {
    const variantId = variantActionBtn.dataset.variantId;
    variantActionBtn.classList.add('loading');
    variantActionBtn.textContent = 'ADICIONANDO...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) throw new Error('Erro ao adicionar ao carrinho');

      variantActionBtn.classList.remove('loading');
      variantActionBtn.classList.add('success');
      variantActionBtn.textContent = 'ADICIONADO ✓';

      window.location = '/cart'

    } catch (err) {
      console.error(err);
      variantActionBtn.classList.remove('loading');
      variantActionBtn.textContent = 'Erro, tente novamente';
    }
  }
})